import React from 'react';
import { Link } from 'react-router-dom';
import CookieMonster from './CookieMonster/CookieMonster';
import './Footer.css';

const footer = () => {
  return (
    <footer>
      <div className="footer-content">
        Všechna práva vyhrazena, Copyright © {new Date().getFullYear()} Doktor Triceratops. Kopírování textů, obrázků a dalších materiálů není bez písemného svolení kapely dovoleno.
        Návrhy a připomínky můžete směřovat přes náš <Link to={'/kontakt'}>kontakt</Link>.
        <span className="hidden">
          Verze webu: v1.0.2
        </span>
      </div>
      <CookieMonster />
    </footer>
  );
}

export default footer;